import { render, staticRenderFns } from "./Scans.vue?vue&type=template&id=5af124a6&scoped=true&"
import script from "./Scans.vue?vue&type=script&lang=js&"
export * from "./Scans.vue?vue&type=script&lang=js&"
import style0 from "./Scans.vue?vue&type=style&index=0&id=5af124a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af124a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af124a6')) {
      api.createRecord('5af124a6', component.options)
    } else {
      api.reload('5af124a6', component.options)
    }
    module.hot.accept("./Scans.vue?vue&type=template&id=5af124a6&scoped=true&", function () {
      api.rerender('5af124a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/compliance/Scans.vue"
export default component.exports